import { getMyNotification } from "@/services";
import { NOTIFICATION_QUERY_KEYS } from "@/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useState } from "react";

export function useGetMyNotification() {
  const [filter] = useState({
    isPagination: 1,
    order: "DESC",
    orderBy: "created_at",
  });

  const {
    data,
    isLoading,
    error,
    isFetched,
    fetchNextPage,
    hasNextPage,
    isFetching,
  } = useInfiniteQuery({
    queryKey: [NOTIFICATION_QUERY_KEYS.MY_NOTIFICATIONS],
    queryFn: ({ pageParam }) =>
      getMyNotification({ page: pageParam, ...filter } as any),
    getNextPageParam: (lastPage) => {
      return lastPage.pagination?.hasNextPage
        ? lastPage.pagination.page + 1
        : undefined;
    },
    initialPageParam: 1,
    retry: 1,
  });

  const notis = data?.pages.flatMap((page) => page.data) || [];
  return {
    notifications: notis,
    isLoading,
    isFetching,
    error,
    isFetched,
    fetchNextPage,
    hasNextPage,
    isLoadFull: !hasNextPage && !!notis.length,
  };
}
